import { render, staticRenderFns } from "./EnvioApp.vue?vue&type=template&id=b45b9c84"
import script from "./EnvioApp.vue?vue&type=script&lang=js"
export * from "./EnvioApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports